export default __webpack_public_path__ + "static/media/deckIcon.685c4975.webp";